module.exports = __webpack_public_path__ + "img/novi-clio.1e15ee1a.jpg";